import { useHistory } from 'react-router';
import { useContext } from 'react';
import MetricsInspectionContext from '../../state/context';
import usePeriods from '../../state/hooks/usePeriods';
import { copyToClipboard } from 'common/utils/clipboard.utils';
import { useDispatch, useSelector } from 'react-redux';
import { toggleSnackBar } from 'state/actions';
import QueryString from 'query-string';
import { organizationSelector } from 'state/selectors/organization';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { LBButton } from '@linearb/buzz';

const CopyLink = () => {
  const history = useHistory();
  const organization = useSelector(organizationSelector);
  const dispatch = useDispatch();
  const {
    state: {
      isPublic,
      widget,
      filters: { team }
    }
  } = useContext(MetricsInspectionContext);
  const { lastPeriod } = usePeriods();

  const onClickCopyLink = () => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.METRICS_INSPECTION,
      click_type: TRACKING.CLICK.COPY_LINK,
      widget_name: widget?.name
    });
    const search = QueryString.parse(history.location.search, {
      ignoreQueryPrefix: true
    });

    search.selectedTimeRanges = `${lastPeriod.after},${lastPeriod.before}`;
    search.inspectingWidgetId = widget.id;
    search.organizationId = organization.id;
    search.context = 'org';
    if (team) {
      search.teams = team.id;
      search.context = 'team';
    }
    const pathurl = [
      window.location.origin,
      history.location.pathname,
      '?',
      new URLSearchParams(search).toString()
    ].join('');

    copyToClipboard({
      snackbarText: 'Inspection URL was copied to your clipboard',
      value: pathurl,
      toggleSnackBar: params => dispatch(toggleSnackBar(params))
    });
  };

  return isPublic ? (
    <LBButton variant='outline' onClick={onClickCopyLink}>
      Share
    </LBButton>
  ) : (
    <></>
  );
};

export default CopyLink;
